var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvito(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 84 84",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.65 83.1C73.0487 83.1 83.0999 73.0487 83.0999 60.65C83.0999 48.2512 73.0487 38.2 60.65 38.2C48.2512 38.2 38.2 48.2512 38.2 60.65C38.2 73.0487 48.2512 83.1 60.65 83.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.45 71.1C24.2214 71.1 28.9 66.4213 28.9 60.65C28.9 54.8786 24.2214 50.2 18.45 50.2C12.6786 50.2 8 54.8786 8 60.65C8 66.4213 12.6786 71.1 18.45 71.1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.65 32.9C68.6305 32.9 75.0999 26.4305 75.0999 18.45C75.0999 10.4695 68.6305 4 60.65 4C52.6694 4 46.2 10.4695 46.2 18.45C46.2 26.4305 52.6694 32.9 60.65 32.9Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.45 36.9C28.6397 36.9 36.9 28.6397 36.9 18.45C36.9 8.26035 28.6397 0 18.45 0C8.26035 0 0 8.26035 0 18.45C0 28.6397 8.26035 36.9 18.45 36.9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvito);
export default __webpack_public_path__ + "static/media/avito.e82da1c6.svg";
export { ForwardRef as ReactComponent };